var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.764 8.01562C1.764 11.4542 4.56146 14.2516 8 14.2516C11.4385 14.2516 14.236 11.4542 14.236 8.01562C14.236 4.57708 11.4385 1.77963 8 1.77963C4.56146 1.77963 1.764 4.57708 1.764 8.01562ZM0 8.01562C0 3.60436 3.58874 0.015625 8 0.015625C12.4113 0.015625 16 3.60436 16 8.01562C16 12.4269 12.4113 16.0156 8 16.0156C3.58874 16.0156 0 12.4269 0 8.01562ZM7.99988 6.81283L10.2972 4.51562L11.5 5.71842L9.20295 8.01562L11.5 10.3126L10.2972 11.5156L7.99988 9.21842L5.70283 11.5156L4.5 10.3126L6.79705 8.01562L4.5 5.71842L5.70283 4.51562L7.99988 6.81283Z",
    fill: "#9C0303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipped);
export default __webpack_public_path__ + "static/media/skipped.2780ee016da84fa93e06bba3502f085c.svg";
export { ForwardRef as ReactComponent };